import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { M8BillRow } from 'services/production/types';
import { TextComponent } from 'design/text/textComponents';
import {
  SmallTableExtraComponent,
  SmallTableRowComponent,
} from 'design/smallTable';
import { ClickControlComponent } from 'design/clickControl/clickControlComponents';

type Props = {
  m8BillRow: M8BillRow;
  onEditRefund(refundId: number): void;
  onManageBill(billId: number): void;
  onManageCardPayment(paymentId: number): void;
  onManageGiroPayment(paymentId: number): void;
};

export const ClientDetailsBillRow = (props: Props) => {
  const {
    m8BillRow,
    onEditRefund,
    onManageBill,
    onManageCardPayment,
    onManageGiroPayment,
  } = props;

  const {
    clientDetailsBillRow: dictionary,
    shared: sharedDictionary,
  } = useIntlDictionary();

  const primaryAmountText = dictionary.primaryAmountText(m8BillRow);

  const titleText = dictionary.titleText(m8BillRow);

  const dateText = sharedDictionary.dates.calendarDateWithTime(
    new Date(m8BillRow.paymentDate)
  );

  const statusText = dictionary.statusText(m8BillRow);

  const isIncome =
    m8BillRow.type === 'BY_CARD' || m8BillRow.type === 'CASHLESS';

  return (
    <SmallTableRowComponent>
      <TextComponent>{dateText}</TextComponent>
      <TextComponent>
        {m8BillRow.type === 'DEBIT' ? (
          <ClickControlComponent onClick={() => onManageBill(m8BillRow.id)}>
            <TextComponent color="accent">{titleText}</TextComponent>
          </ClickControlComponent>
        ) : m8BillRow.type === 'CASHLESS' ? (
          <ClickControlComponent
            onClick={() => onManageGiroPayment(m8BillRow.id)}
          >
            <TextComponent color="accent">{titleText}</TextComponent>
          </ClickControlComponent>
        ) : m8BillRow.type === 'BY_CARD' ? (
          <ClickControlComponent
            onClick={() => onManageCardPayment(m8BillRow.id)}
          >
            <TextComponent color="accent">{titleText}</TextComponent>
          </ClickControlComponent>
        ) : (
          titleText
        )}
        <br />
        {m8BillRow.type === 'REFUND' ? (
          <ClickControlComponent onClick={() => onEditRefund(m8BillRow.id)}>
            <TextComponent color="accent">
              {dictionary.editRefundButtonText}
            </TextComponent>
          </ClickControlComponent>
        ) : (
          statusText
        )}
      </TextComponent>
      <SmallTableExtraComponent>
        <TextComponent color={isIncome ? 'successful' : 'primary'}>
          {primaryAmountText}
        </TextComponent>
      </SmallTableExtraComponent>
    </SmallTableRowComponent>
  );
};
